import * as types from './types';
import { CLEAR_RECOGNITION } from '../../../app-dux/recognition/types';

/*******************************************************************************
 * Initial state
 */
 const initialState = {
     rewardChoices: [],
     selectedBehavior: '',
     selectedProgram: {}
};

/*******************************************************************************
 * Reducer
 */
export default function appReducer( state = initialState, action ) {
    switch ( action.type ) {
        case types.SET_PROGRAMS_AND_REWARDS: {
            return {
                ...state,
                rewardChoices: action.prs
            };
        }
        case types.SET_SELECTED_BEHAVIOIR: {
            return {
                ...state,
                selectedBehavior: action.behavior
            };
        }
        case types.SET_SELECTED_PROGRAM: {
            return {
                ...state,
                selectedProgram: action.selectedProgram
            };
        }
        case CLEAR_RECOGNITION: {
            return {
                ...state,
                selectedProgram: {}
            };
        }
        default:
            return state;
    }
}
